export default __webpack_public_path__ + "static/media/Firstmeet1.744c7e48.jpg";